/**
 * A list whose items are separated by a hairline.
 *
 * The divider between siblings is a state a style attribute cannot express,
 * so it is the one rule in layer.css a page reaches through a component.
 */
import type { CSSProperties, ReactNode } from 'react';

interface DividedListProps {
  /** The element: a `ul` for items, a `div` for rows that are not list items. */
  as?: 'ul' | 'div' | undefined;
  style?: CSSProperties | undefined;
  children: ReactNode;
}

export function DividedList({ as: Tag = 'ul', style, children }: DividedListProps) {
  return (
    <Tag className="ui-divide" style={{ listStyle: 'none', margin: 0, padding: 0, ...style }}>
      {children}
    </Tag>
  );
}
